import styled from "styled-components";
import { IonContent } from "@ionic/react";

export const Container = styled(IonContent)`
  background-color: white;
`;

export const ImgContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
`;

export const TopRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 10px;
`;

export const ImgItem = styled.div`
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
  margin: 10px;
  overflow: hidden;
  border-radius: 15px;
  float: left;
`;

export const PickerImgItem = styled.div`
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
  margin: 10px;
  overflow: hidden;
  border-radius: 15px;
  background-color: #e8edfc;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  color: gray;
`;

export const CloseCircle = styled.div `
  margin-left: -30px;
  margin-top: 5px;
  padding-top: 0.05rem;
  padding-left: 0.05rem;
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 50%;
  color: red;
  background-color: white;
  z-index: 999;
`;

export const StyledLink = styled.div`
    color:#fff;
    text-decoration: none;
`
